const STRIPE_PUBLISHABLE = 'pk_test_ekHZnebrMV55iWuUWttsAJ2c00C2iiL805';

export default STRIPE_PUBLISHABLE;